import React from "react";
import { BlockStyleProps } from "sanity";

const DisclaimerTextBoxStyle: React.FC<BlockStyleProps> = ({ children }) => (
  <span style={{ color: "#a4a4a8", fontSize: "0.75rem" }}>{children}</span>
);

export default DisclaimerTextBoxStyle;
